import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { Button, Form, Row, Col, FormGroup, Label, Input } from "reactstrap";
import ContactFields from "./ContactFields";

const ClaimForm = ({ onSubmit, inputType }, context) => {
  const { handleSubmit, control, errors } = useFormContext();

  const infoText = {
    physicalAddress: context.t("inputType.physicalAddress"),
    walletAddress: context.t("inputType.walletAddress"),
    imxPassportAddress: context.t("inputType.imxPassportAddress"),
  };

  return (
    <>
      <p>{infoText[inputType]}</p>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {inputType === "physicalAddress" && <ContactFields />}
        {inputType === "walletAddress" && (
          <Row>
            <Col>
              <FormGroup>
                <Label for="formWalletAddress">
                  {context.t("Wallet Address")}
                </Label>
                <Controller
                  name="formWalletAddress"
                  control={control}
                  rules={{ required: { value: true, message: "is required" } }}
                  render={({ field }) => (
                    <Input id="formWalletAddress" type="text" {...field} />
                  )}
                />
                {errors.formWalletAddress && (
                  <span role="alert" className="small text-danger">
                    {errors.formWalletAddress.message}
                  </span>
                )}
              </FormGroup>
            </Col>
          </Row>
        )}
        {inputType === "imxPassportAddress" && (
          <Row>
            <Col>
              <FormGroup>
                <Label for="imxPassportAddress">
                  {context.t("IMX Passport Address")}
                </Label>
                <Controller
                  name="imxPassportAddress"
                  control={control}
                  rules={{ required: { value: true, message: "is required" } }}
                  render={({ field }) => (
                    <Input id="imxPassportAddress" type="text" {...field} />
                  )}
                />
                {errors.imxPassportAddress && (
                  <span role="alert" className="small text-danger">
                    {errors.imxPassportAddress.message}
                  </span>
                )}
              </FormGroup>
            </Col>
          </Row>
        )}

        {errors?.root?.message && (
          <p className="text-danger">{errors.root.message}</p>
        )}
        <Button color="primary" className="mt-5 w-100">
          {context.t("Submit")}
        </Button>
      </Form>
    </>
  );
};

ClaimForm.contextTypes = {
  t: PropTypes.func,
};

ClaimForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  inputType: PropTypes.oneOf([
    "physicalAddress",
    "walletAddress",
    "imxPassportAddress",
  ]).isRequired,
};

ClaimForm.defaultProps = {};

export default ClaimForm;
